// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import JS
import navigation from "./navigation";
import infiniteScroll from "./infiniteScroll";
import animations from "./animations";
import Headroom from "headroom.js";
import copyToClipboard from "./copyToClipboard";

let email = '\u0068\u0065\u006c\u006c\u006f\u0040\u0062\u0069\u0067\u0065\u0063\u0068\u006f\u002e\u0063\u006f\u002e\u0075\u006b';

// Headroom fixed header
let myElement = document.querySelector("header");
let headroom  = new Headroom(myElement, {
    offset: {
        up: 0,
        down: 110
    },
    onUnpin : function() {
        setTimeout(() => {
            myElement.classList.add("transition");
        }, 10);
    },
    onTop : function() {
        myElement.classList.remove("transition");
    },
});

// initialise
headroom.init();

// Populate email
document.querySelectorAll('[data-email]').forEach((element) => {
    element.innerHTML = email;
    element.setAttribute('href',"javascript:location='mailto:\u0068\u0065\u006c\u006c\u006f\u0040\u0062\u0069\u0067\u0065\u0063\u0068\u006f\u002e\u0063\u006f\u002e\u0075\u006b';void 0");
});

// External links
document.querySelectorAll("main a[href^=http]:not([href*='//bigecho.co.uk']), main a[href^='//']:not([href*='//bigecho.co.uk']), main a[target='_blank']").forEach(function(element) {
    // Open link in new tab always, regardless of target attribute
    element.addEventListener('click', function(event) {
        event.preventDefault();
        window.open(element.href);
    });
});

// Add UTM to URL after page load
// document.addEventListener("DOMContentLoaded", function() {
//     setTimeout(() => {
//         let url = new URL(window.location.href);
//         url.searchParams.set("utm_source", "manualshare");
//         window.history.replaceState(null, "", url);
//     }, 1000);
// });

navigation();
infiniteScroll();
animations();
copyToClipboard(email);